import { render, staticRenderFns } from "./downloadElcPolicy.vue?vue&type=template&id=76a32ca4"
import script from "./downloadElcPolicy.vue?vue&type=script&lang=js"
export * from "./downloadElcPolicy.vue?vue&type=script&lang=js"
import style0 from "./downloadElcPolicy.vue?vue&type=style&index=0&id=76a32ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports